module.exports = __webpack_public_path__ + "img/Icon_Bell_Home.345f124b.svg";